import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import styles from "./todo.module.css";
import "./payment-section.scss";
import { addCommas } from "@persian-tools/persian-tools";
import { connection } from "utils/apiConnection.ts";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Loader from "utils/Loader";
function MyPay({
  item,
  setItems,
  ChangeModalStar,
  prices,
  currentInventory,
  addressId,
  shoppingDataBusiness,
  setShow,
}) {
  const [payType, setPayType] = useState("");
  const [url, settUrl] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const nav = useNavigate();
  useEffect(() => {
    payType == "" ? setDisableBtn(true) : setDisableBtn(false);
  }, [payType]);
  const paySection = () => {
    if (payType == "online") {
      return (
        <div className={`${styles.factorBooxText} m-4`}>
          <span className={styles.factorBooxHead}>مبلغ قابل پرداخت : </span>
          <span className={styles.factorBooxspan}>
            {" "}
            {addCommas(prices.total + prices.send)}
          </span>
        </div>
      );
    } else if (payType == "wallet") {
      return (
        <>
          <div className={`${styles.factorBooxText} m-4`}>
            <span className={styles.factorBooxHead}>موجودی کیف پول : </span>
            <span className={styles.factorBooxspan}>
              {currentInventory != "" ? addCommas(currentInventory) : 0}
            </span>
          </div>
          <div className={`${styles.factorBooxText} m-4`}>
            <span className={styles.factorBooxHead}>مبلغ قابل پرداخت : </span>
            <span className={styles.factorBooxspan}>
              {addCommas(
                prices.total + prices.send - currentInventory > 0
                  ? prices.total + prices.send - currentInventory
                  : 0
              )}
            </span>
          </div>
        </>
      );
    }
  };

  const pay = () => {
    setIsLoading(true);
    let orderInfo = { address_id: addressId };
    if (payType == "online") {
      orderInfo = { ...orderInfo, pay_type: 0 };
    } else if (
      payType == "wallet" &&
      currentInventory >= prices.total + prices.send
    ) {
      orderInfo = { ...orderInfo, pay_type: 1 };
    } else if (
      payType == "wallet" &&
      currentInventory < prices.total + prices.send
    ) {
      orderInfo = { ...orderInfo, pay_type: 2 };
    }
    let temp = {
      regOrderKeys: [],
      delivery_Type: [],
      delivery_price: [],
      delivery_discount: [],
      delivery_needtm: [],
      address_id: addressId,
      payonline: true,
      useWallet: payType == "wallet" ? true : false,
      descriptions: [],
    };
    for (let i = 0; i < shoppingDataBusiness.length; i++) {
      temp.regOrderKeys.push(shoppingDataBusiness[i].regOrderkey);
      temp.descriptions.push(shoppingDataBusiness[i].description);
      for (const k in shoppingDataBusiness[i].delivery) {
        if (shoppingDataBusiness[i].delivery[k].status == true) {
          temp.delivery_Type.push(k);
          temp.delivery_price.push(shoppingDataBusiness[i].delivery[k].price);
          temp.delivery_discount.push(
            shoppingDataBusiness[i].delivery[k].discount
          );
          temp.delivery_needtm.push(shoppingDataBusiness[i].delivery[k].time);
        }
      }
    }
    temp = {
      ...temp,
      regOrderKeys: temp.regOrderKeys.toString(),
      delivery_Type: temp.delivery_Type.toString(),
      descriptions: temp.descriptions.toString(),
      delivery_discount: temp.delivery_discount.toString(),
      delivery_needtm: temp.delivery_needtm.toString(),
      delivery_price: temp.delivery_price.toString(),
    };
    connection("order/reg_order1", temp).then((data) => {
      if (data.status == 1) {
        toast("سفارش شما با موفقیت ثبت شد.");

        if (data.paylink != "") {
          setIsLoading(false);
          // setTimeout(() => {
          //   setTxt("متاسفانه مشکلی در درگاه پرداخت پیش آمده است.");
          // }, 6000);
          window.location.href = `${data.paylink}`;
        } else {
          setIsLoading(false);
          nav("/customer-panel#orders");
          setShow(false);
        }
      } else {
        toast.error("متاسفانه مشکلی پیش آمده است.");
        setIsLoading(false);
      }
    });

    console.log(shoppingDataBusiness, "shoppingDataBusiness");
    // console.log(orderInfo);
    // connection("api/reg_order", orderInfo).then((data) => {
    //   if (data.status == 1 && payType == "online") {
    //     nav(data.url);
    //   } else if (payType == "wallet") {
    //     nav("/customer-panel/profile");
    //   }
    // });
  };

  return (
    <div
      className=" d-flex justify-content-between flex-column align-items-between  mx-auto "
      style={{
        minHeight: "50vh",
        backgroundColor: "white",
        width: "95%",
        borderRadius: "10px",
      }}
    >
      {isLoading && <Loader />}
      <div
        className={`${styles.factorBoox} ${styles.factorResponse} mx-auto my-5 shadow`}
      >
        <div className={`${styles.factorBooxText} m-4`}>
          <span className={styles.factorBooxHead}>مبلغ نهایی : </span>
          <span className={styles.factorBooxspan}>
            {addCommas(prices.total + prices.send)}
          </span>
        </div>
        {paySection()}

        <div className={`${styles.factorBooxText} m-4`}>
          <span className={styles.factorBooxHead}> شیوه پرداخت : </span>
          <span className={styles.factorBooxspan}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
                checked={payType === "online"}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPayType("online");
                  }
                }}
              />
              <label
                className={`form-check-label ${styles.kif}`}
                for="flexRadioDefault1"
              >
                آنلاین
              </label>
            </div>
            <div className="form-check ">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault2"
                checked={payType === "wallet"}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPayType("wallet");
                  }
                }}
              />
              <label
                className={`form-check-label ${styles.kif3}`}
                for="flexRadioDefault2"
              >
                کیف پول
              </label>
            </div>
          </span>
        </div>

        <div className="w-100 d-flex me-4 justify-content-end m-4">
          <div className="form-check mt-2 me-3 "></div>
          <div>
            <button
              className={`btn  rounded text-light continueHover`}
              style={{
                fontWeight: "bold",
                backgroundColor: "rgb(246, 102, 86)",
              }}
              onClick={pay}
              disabled={disableBtn}
            >
              {" "}
              پرداخت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyPay;
